import { Identifier } from 'src/types/utilityTypes';
import api from 'src/utils/ajax';

import { denormalize } from '../shared/normalizers';
import { User } from '../user/_types';

import { ProgressPhoto, ProgressPhotoAsset } from './_types';
import {
  denormalizeProgressPhoto,
  normalizeProgressPhoto,
  normalizeProgressPhotoAsset,
} from './normalizers';
export * from './_types';

export const fetchProgressPhotos = async ({ userId }) => {
  const response = await api.get(`/api/v2/progress-photos/`, {
    params: { user_id: userId },
  });

  return response.data.map(normalizeProgressPhoto);
};

export const createProgressPhoto = async (
  userId: User['id'],
  progressPhoto: Partial<ProgressPhoto>
): Promise<ProgressPhoto> => {
  const response = await api.post('/api/v3/progress-photos', {
    asset: denormalizeProgressPhoto(progressPhoto),
    user_id: userId,
  });
  return normalizeProgressPhoto(response.data);
};

export const updateProgressPhoto = async (
  progressPhoto: Partial<ProgressPhoto>
): Promise<ProgressPhoto> => {
  try {
    const response = await api.put(
      `/api/v3/progress-photos/${progressPhoto.id}`,
      progressPhoto
    );
    return normalizeProgressPhoto(response.data);
  } catch (error) {
    throw new Error(api.formatError(error, 'Error updating progress photo.'));
  }
};

export const uploadProgressPhoto = async (
  userId: number,
  file: File
): Promise<ProgressPhotoAsset> => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await api.post(
    `/api/v3/progress-photos/upload/?user_id=${userId}`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );

  return normalizeProgressPhotoAsset(response.data);
};

export const deleteProgressPhoto = async (
  progressPhotoId: ProgressPhoto['id'],
  userId?: Identifier | null
) => {
  try {
    await api.delete(`/api/v2/progress-photos/${progressPhotoId}`, {
      params: { user_id: userId },
    });
  } catch (error) {
    throw new Error(api.formatError(error, 'Error deleting progress photo.'));
  }
};

export const updateProgressPhotoCaption = async ({
  data,
  progressPhotoId,
  userId,
}: {
  data: Partial<ProgressPhoto>;
  progressPhotoId: ProgressPhoto['id'];
  userId?: Identifier | null;
}) => {
  try {
    const id = userId ? `?user_id=${userId}` : '';
    const response = await api.put(
      `/api/v2/progress-photos/${progressPhotoId}/caption${id ?? ''}`,
      denormalize(data)
    );
    return normalizeProgressPhoto(response.data);
  } catch (error) {
    throw new Error(api.formatError(error, 'Error updating progress photo.'));
  }
};
